






import { Component, Prop, Vue } from 'vue-property-decorator';
import Member from '@/models/Member';
import MemberListItem from '@/browser/atoms/MemberListItem.vue';
import SimpleDialog from '@/browser/moleculers/SimpleDialog.vue';

@Component({
  components: {
    MemberListItem,
    SimpleDialog,
  },
})
export default class MemberListDialog extends Vue {
  @Prop({ required: true }) private members!: Member[];
  @Prop({ required: true }) private value!: boolean;
}
